/**
 * Runtime debug switch, toggled via 
 * localStorage.setItem('DEBUG', 'true'); window.location.reload();
 * 
 * Use it to gate verbose logging and on-page debug widgets. Safe to call
 * anywhere: returns `false` during SSR and when storage access throws (Safari
 * private mode, cookies disabled).
 */
export const DEBUG_STORAGE_KEY = 'DEBUG';

export const isDebugEnabled = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return !!window.localStorage.getItem(DEBUG_STORAGE_KEY);
  } catch {
    return false;
  }
};

/**
 * `console.log` that only fires when debug mode is enabled
 */
export const debugLog = (...args: unknown[]): void => {
  if (isDebugEnabled()) console.log(...args);
};
